import { render } from "./Cgu.component.vue?vue&type=template&id=c7a49aa0"
import script from "./Cgu.component.vue?vue&type=script&lang=js"
export * from "./Cgu.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__